export enum formLayoutEnum {
  FullScreen = 1,
  Split = 2,
  Worksheet = 3,
  DiagnosisHorizontal = 4,
  DiagnosisVertical = 5,
  Diagnosis = 6
}
